import { render, staticRenderFns } from "./historie.vue?vue&type=template&id=1c6eb661&scoped=true"
import script from "./historie.vue?vue&type=script&lang=js"
export * from "./historie.vue?vue&type=script&lang=js"
import style0 from "./historie.vue?vue&type=style&index=0&id=1c6eb661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6eb661",
  null
  
)

export default component.exports